<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useTitle } from '@vueuse/core';

import { useLogout } from '@/shared/composables/useLogout';

useTitle('Access Denied');

const route = useRoute();
const { logout } = useLogout();

const loggingOut = ref(false);

const customMessage = computed(() => route.query.message as string | undefined);

const error = computed(() => ({
  statusCode: 403,
  statusMessage: 'Access denied',
  message: customMessage.value || 'You don\'t have permission to view this page.',
}));

const handleLogout = async () => {
  loggingOut.value = true;
  await logout();
};
</script>

<template>
  <UError
    :error="error"
    :clear="false"
    data-testid="u-error"
  >
    <template #links>
      <div class="flex flex-col sm:flex-row gap-3">
        <RouterLink
          :to="{ name: 'Home' }"
        >
          <UButton
            size="lg"
            color="primary"
            label="Go home"
            @click.stop
          />
        </RouterLink>
        <UButton
          size="lg"
          color="primary"
          variant="solid"
          label="Sign out"
          :loading="loggingOut"
          @click="handleLogout"
        />
      </div>
    </template>
  </UError>
</template>
